import React from 'react';
import classnames from 'classnames';
import path from 'path-browserify';

import StrapiLink from '../StrapiLink/StrapiLink';
import Tag from '../Tag';

import * as styles from './CareersCard.module.scss';

type Props = {
  title?: string;
  short?: string;
  jobType: string;
  city: string;
  slug: string;
  slugBase: string;
  linkText: string;
  cityIsActive?: boolean;
  jobIsActive?: boolean;
};

const CareersCard: React.FC<Props> = ({
  title,
  slug,
  short,
  jobType,
  city,
  cityIsActive,
  jobIsActive,
  slugBase,
  linkText,
}) => (
  <div className={styles.careersCard} data-testid="careersCard">
    <div className={classnames('bg-black-5', styles.cardSquare)}>
      <h3 className="title color-a is-3 mb-2">{title}</h3>
      {jobType?.length ? <Tag isActive={jobIsActive} isClickable={false} name={jobType} /> : null}
      {city?.length ? <Tag isActive={cityIsActive} isClickable={false} name={city} /> : null}
      <p className="py-2 is-text-2">{short}</p>
      <div>
        <StrapiLink title={linkText} url={path.join(slugBase, slug)} openInNewWindow={false} />
      </div>
    </div>
  </div>
);

export default CareersCard;
